exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-row-text-field{min-width:300px}.table-row-code-text{white-space:nowrap;overflow:hidden;max-width:60ch;text-overflow:ellipsis;display:inline-block}\n", ""]);

// exports
